// @flow

import React from "react";
import { localize } from "redux-i18n";

import { ColumnsContainer, View, Col } from "@components";
import type { Rows } from "@components/columns-container/types";

type Props = $Exact<{
  data: Object,
  processId?: number,
  ...PropsFromLocalize,
}>;

export class RtwSettingsView extends React.Component<Props> {
  get data(): Array<Rows> {
    return [
      {
        columns: [
          {
            data: [
              [
                this.props.t("RETURN_TO_WORK_PROCESS_ID_VIEW"),
                this.props.processId ? this.props.processId : "",
              ],
              [this.props.t("RETURN_TO_WORK_PROCESS_NAME"), this.props.data.name],
              [this.props.t("RETURN_TO_WORK_LENGTH_SCOPE"), this.props.data.lengthScope],
            ],
          },
          {
            data: [
              [
                this.props.t("RETURN_TO_WORK_ABSENCE_TYPE_SCOPE"),
                this.props.t(this.props.data.absenceTypeScope),
              ],
              [
                this.props.t("STATUS"),
                this.props.data.isActive ? this.props.t("ACTIVE") : this.props.t("INACTIVE"),
              ],
              [
                this.props.t("RETURN_TO_WORK_REASON_SCOPE"),
                this.props.t(this.props.data.reasonScope),
              ],
            ],
          },
        ],
      },
    ];
  }

  render() {
    return <ColumnsContainer rows={this.data} />;
  }
}

export default localize()(RtwSettingsView);
